import { Injectable, inject } from "@angular/core";
import { BaseApiService } from "../base/base-api.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, map } from "rxjs";
import { FrequencyChart, FrequencyChartsWrapper } from "../../interfaces/frequency-chart.interface";
import { ResponseContainer } from "../../interfaces/response-container.interface";

@Injectable({
  providedIn: "root",
})
export class AnswerDataService {
  private baseApiService = inject(BaseApiService);
  private http = inject(HttpClient);

  getFrequencyCharts(from?: string, to?: string): Observable<FrequencyChart[]> {
    let params = new HttpParams();
    if (from) params = params.set("from", from);
    if (to) params = params.set("to", to);
    const response = this.http
      .get<ResponseContainer<FrequencyChartsWrapper>>(
        `${this.baseApiService.rootUrl}/back-office/answer-data/frequency-charts`,
        { params },
      )
      .pipe(
        map((x) => x.data),
        map((chartsWrapper) => chartsWrapper.charts),
        map((charts) =>
          // Fiter "other" datapoints when no items present
          charts.map((chart) => {
            chart.dataPoints = chart.dataPoints.filter(
              (x) => !(x.label.toLowerCase() == "other" && x.answerCount == 0),
            );
            return chart;
          }),
        ),
        map((charts) =>
          // Filter out questions that have no answers
          charts.filter((x) => !(x.dataPoints == null || x.dataPoints.length == 0)),
        ),
      );
    return response;
  }
}
